import { IFieldInstance } from "../../../types/fieldInstance.interface";
import { getRLType } from "../../helpers/relatedListHelpers";

function isNotBooleanControlled(
  id: string,
  fields: IFieldInstance[],
  record: any
): boolean {
  const field = fields.find((field) => field.id === id);
  if (field) {
    const childFields = fields.filter((_field) =>
      field.childFieldIds.includes(_field.id)
    );
    return childFields.every(
      (_field) => _field.dataType === "Boolean" && record[_field.fieldName]
    );
  }
  return false;
}

export function isActiveRecordSubmittable(
  active: boolean | undefined,
  value: any[],
  fieldName: string,
  rlViewModel: any,
  fields: IFieldInstance[]
) {
  const index = typeof active === "number" ? active : value.length - 1;
  const rlType = getRLType(fieldName);
  const viewModel = rlType && rlViewModel[rlType][index];
  const visibleFields = Object.keys(viewModel).filter((key) => viewModel[key]);
  const requiredFields = fields.filter(
    (field) =>
      visibleFields.includes(field.id) &&
      field.required &&
      !isNotBooleanControlled(field.id, fields, value[index])
  );
  return viewModel
    ? requiredFields.every((field) => value[index][field.fieldName])
    : true;
}
